import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'Mariana P.',
  role: 'Docente de Historia — Ciudad de México, México',
  text: '"Mis alumnos por fin entienden la diferencia entre el período clásico y el posclásico sin confundirse. Antes yo misma perdía tiempo buscando cómo explicarlo bien. Ahora entro al aula con todo listo y ellos llegan con preguntas reales."'
}, {
  initials: 'JR',
  name: 'Jorge R.',
  role: 'Profesor de Historia — Guadalajara, México',
  text: '"Nunca más llegué a una clase sin saber cómo explicar la Conquista o el Virreinato en profundidad. El material hace el trabajo pesado por mí y yo me concentro en lo que importa: enseñar."'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  role: 'Docente de secundaria — Monterrey, México',
  text: '"Las actividades y evaluaciones me ahorran horas cada semana. No improviso nunca más frente a mis alumnos y eso se nota en el nivel de mis clases."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-ivory border-y border-beige" data-id="element-281">
      <div className="max-w-7xl mx-auto px-4" data-id="element-282">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-283">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white border border-beige p-6 rounded-2xl relative shadow-sm" data-id="element-284">
              <div className="flex gap-1 text-gold mb-4" data-id="element-285">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-286" />)}
              </div>
              <p className="text-warmgray italic mb-6 text-sm leading-relaxed" data-id="element-287">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-288">
                <div className="w-10 h-10 rounded-full bg-forest/10 border border-forest/20 flex items-center justify-center text-forest font-bold" data-id="element-289">
                  {t.initials}
                </div>
                <div data-id="element-290">
                  <div className="font-bold text-ink text-sm" data-id="element-291">{t.name}</div>
                  <div className="text-xs text-terracotta" data-id="element-292">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}